import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { useUserInfo } from '../../../../hooks';
import { emailRegExp } from '../../../../utils/utilityEtc';
import { TYPE } from '../../../../constant';

function EmailForm({
  email,
  hide_m = true,
  onChangeEmail,
  onBlur,
  emailCheck,
  onEmailReset,
  handleMouseDown,
  btnType,
  handleSend,
}) {
  const { info } = useUserInfo();
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="lr_wrap">
        <div className="input_box white_box">
          <input
            type="email"
            name="email"
            placeholder={t("MY_05_02.msg006")}
            value={email}
            onChange={onChangeEmail}
            onBlur={onBlur}
          />
          <div className="r_area">
            {(emailCheck === 'success' && email.length > 0) && <img src="./static/images/icon/ic_check.svg" alt="" />}
            {emailCheck === 'fail' && (
              <button
                type="button"
                onClick={onEmailReset}
                onMouseDown={handleMouseDown}
              >
                < img src="./static/images/icon/ic_error.svg" alt="" />
              </button>
            )}
            {(emailCheck === '' && email.length > 0) && (
              <button
                type="button"
                onClick={onEmailReset}
                onMouseDown={handleMouseDown}
              >
                <img src="./static/images/icon/input_delete_40.svg" alt="" />
              </button>
            )}
          </div>
        </div>
        <div className={clsx(
          "right_area",
          hide_m && "hide_m"
        )}>
          {btnType === 'auth' && (
            <button
              className={clsx(
                "btn btn-blue",
                info.channelCode !== TYPE.CHANNEL.GLOBAL01 ? '' : 'm_txt'
              )}
              onClick={handleSend}
              disabled={!emailRegExp(email)}
            >
              {t("MY_03_01-GM.msg004")}
            </button>
          )}
          {btnType === 'resend' && (
            <button
              className={clsx(
                "btn btn-gray",
                info.channelCode !== TYPE.CHANNEL.GLOBAL01 ? '' : 'm_txt'
              )}
              onClick={handleSend}
            >{t("MY_03_01-GM.msg005")}</button>
          )}

        </div>
      </div>
      {
        emailCheck === 'fail' && (
          <div className="info_txt red">
            {t("MY_01.msg005")} abc@mathpid.com
          </div>
        )
      }
    </React.Fragment>
  );
}

export default EmailForm;